import { render, staticRenderFns } from "./PeopleList.vue?vue&type=template&id=054b83a5"
import script from "./PeopleList.vue?vue&type=script&lang=ts"
export * from "./PeopleList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports